export function getParam( str, key ) {
    let regexS = "[\\?&]" + key + "=([^&#]*)";
    let regex = new RegExp(regexS);
    let results = regex.exec(str);
    if (results == null) {
        return "";
    } else {
        return results[1];
    }
}

/**
 * reformats the release url to a jw player supported release url
 */
 export function reformatReleaseUrl( releaseUrl ) {
    //constructing new release url format
    let releaseId = releaseUrl.match(/BKQ29B\/(.*?)\?/)[1];
    return releaseUrl =  "https://link.theplatform.com/s/BKQ29B/" + releaseId + "?formats=m3u";

}



// WEBPACK FOOTER //
// ./assets/components/fsUtils/fsPlayerUtils.js